export const reportQueryAction= (data) => { 
    return {
       type: data.type,
       data:data.data
    }
 }